import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "boot-type"
  }, [_c("h4", [_vm._v("开机屏类型：")]), _c("el-radio", {
    attrs: {
      label: 1,
      border: ""
    },
    model: {
      value: _vm.config.type,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "type", $$v);
      },
      expression: "config.type"
    }
  }, [_vm._v("图片")]), _c("el-radio", {
    attrs: {
      label: 2,
      border: ""
    },
    model: {
      value: _vm.config.type,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "type", $$v);
      },
      expression: "config.type"
    }
  }, [_vm._v("视频")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.updateBootScreenConfig
    }
  }, [_vm._v("保存")])], 1), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  }, [_c("el-form-item", [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "type", $$v);
      },
      expression: "searchForm.type"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: 1
    }
  }, [_vm._v("图片")]), _c("el-radio-button", {
    attrs: {
      label: 2
    }
  }, [_vm._v("视频")])], 1)], 1)], 1), _c("el-form", [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addDialog
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "开机屏"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.searchForm.type == 1 ? _c("wlc-image", {
          attrs: {
            src: scope.row.url,
            width: "75",
            height: "162",
            compression: true
          }
        }) : _vm._e(), _vm.searchForm.type == 2 ? _c("wlc-video", {
          attrs: {
            src: scope.row.url,
            width: "75",
            height: "162"
          }
        }) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "跳转类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.linkType == 2 ? _c("el-tag", [_vm._v("APP内部页")]) : _vm._e(), scope.row.linkType == 1 ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("H5 链接")]) : _vm._e(), scope.row.linkType == 0 ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("不跳转")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "跳转链接",
      prop: "link"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "操作",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("编辑")]), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删除")]), scope.row.status == 1 ? _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateBootScreenStatus(scope.row);
            }
          }
        }, [_vm._v("关闭")]) : _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateBootScreenStatus(scope.row);
            }
          }
        }, [_vm._v("开启")])];
      }
    }])
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.$route.meta.title, "\u7F16\u8F91"),
      width: "600px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "110px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "资源类型"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v("图片")]), _c("el-radio", {
    attrs: {
      label: 2
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v("视频")])], 1), _c("el-form-item", {
    attrs: {
      label: _vm.form.type == 1 ? "图片" : "视频"
    }
  }, [_vm.form.type == 1 ? _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.url
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  }) : _vm._e(), _vm.form.type == 1 ? _c("wlc-image-info", {
    attrs: {
      url: _vm.form.url
    }
  }) : _vm._e(), _vm.form.type == 2 ? _c("wlc-upload-video", {
    attrs: {
      url: _vm.form.url
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  }) : _vm._e(), _c("div", {
    staticStyle: {
      color: "#999",
      "margin-top": "-10px"
    }
  }, [_vm._v(" 建议尺寸：2倍（750px * 1334px）3倍（1125px * 2001px） ")])], 1), _c("el-form-item", {
    attrs: {
      label: (_vm.form.type == 1 ? "图片" : "视频") + "(全面屏)"
    }
  }, [_vm.form.type == 1 ? _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.fullScreenUrl
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "fullScreenUrl", $event);
      }
    }
  }) : _vm._e(), _vm.form.type == 1 ? _c("wlc-image-info", {
    attrs: {
      url: _vm.form.fullScreenUrl
    }
  }) : _vm._e(), _vm.form.type == 2 ? _c("wlc-upload-video", {
    attrs: {
      url: _vm.form.fullScreenUrl
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "fullScreenUrl", $event);
      }
    }
  }) : _vm._e(), _c("div", {
    staticStyle: {
      color: "#999",
      "margin-top": "-10px"
    }
  }, [_vm._v(" 建议尺寸：2倍（780px * 1688px）3倍（1170px * 2532px） ")])], 1), _c("el-form-item", {
    attrs: {
      label: "跳转类型"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 0
    },
    model: {
      value: _vm.form.linkType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "linkType", $$v);
      },
      expression: "form.linkType"
    }
  }, [_vm._v("不跳转")]), _c("el-radio", {
    attrs: {
      label: 1
    },
    model: {
      value: _vm.form.linkType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "linkType", $$v);
      },
      expression: "form.linkType"
    }
  }, [_vm._v("H5 链接")]), _c("el-radio", {
    attrs: {
      label: 2
    },
    model: {
      value: _vm.form.linkType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "linkType", $$v);
      },
      expression: "form.linkType"
    }
  }, [_vm._v("APP内部页")])], 1), _vm.form.linkType > 0 ? _c("el-form-item", {
    attrs: {
      label: "跳转链接"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.link,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "link", $$v);
      },
      expression: "form.link"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };